import React, { Component } from 'react';
import * as CryptoJS from 'crypto-js';

class CryptoService{
  generateIV=(length)=> {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  
    for (let i = 0; i < length; i++){
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return this.string_to_hex(text);
  }
  string_to_hex=(str)=>{
	  let hex;
    try {
      hex = unescape(encodeURIComponent(str))
        .split("")
        .map((v) => {
          return v.charCodeAt(0).toString(16);
        })
        .join("");
    } catch (e) {
      console.log("invalid text input: " + str);
    }
    return hex;
   }
   
  encryptAES1=(text, key)=>{    
    const parsed_key = CryptoJS.enc.Hex.parse(key);
    const randomText=this.generateIV(16);
    const Iv=CryptoJS.enc.Hex.parse(randomText);
    console.log('parsed_key: ' + parsed_key);
    //const Iv=CryptoJS.lib.WordArray.create(IvWordArray,16);
    
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), parsed_key, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: Iv
    });
    const Base64_IV = CryptoJS.enc.Base64.stringify(Iv);
    return encodeURIComponent(Base64_IV+encrypted.toString());
  }

  encryptAES=(text, key)=>{    
    const parsed_key = CryptoJS.enc.Hex.parse(key);
    console.log('parsed_key: ' + parsed_key);
    
    //const IV =this.generateIV(24); //generateIV();
    //console.log('iv: ' + IV);
     
    //const byte_IV = CryptoJS.enc.Hex.parse(IV);
    const byte_IV = CryptoJS.lib.WordArray.random(16);
    console.log('byte_IV: ' + byte_IV); 
 
    const encrypted_string = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), parsed_key, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: byte_IV
    }).toString();
    const Base64_IV = CryptoJS.enc.Base64.stringify(byte_IV);
    return encodeURIComponent(Base64_IV+encrypted_string);
  }

  


  /**
   * Decrypt an encrypted message
   * @param encryptedBase64 encrypted data in base64 format
   * @param key The secret key
   * @return The decrypted content
   */
  decryptAES = (encryptedBase64, key) => {
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key);
    if (decrypted) {
      try {
        console.log(decrypted);
        const str = decrypted.toString(CryptoJS.enc.Utf8);
        if (str.length > 0) {
          return str;
        } else {
          return 'error 1';
        } 
      } catch (e) {
        return 'error 2';
      }
    }
    return 'error 3';
  };
}
export default CryptoService


// WEBPACK FOOTER //
// ./src/server/cryptoService.js